(function () {
  let isProcessing = false;
  let queuedRun = null;

  function productIsUnavailable(card) {
    const availableSource = card.matches('[data-product-available]')
      ? card
      : card.querySelector('[data-product-available]');

    if (availableSource) {
      return availableSource.dataset.productAvailable === 'false';
    }

    const badge = card.querySelector('.product-badges__badge');
    const badgeText = badge ? badge.textContent.trim().toLowerCase() : '';

    return badgeText.includes('esgotado') || badgeText.includes('sold out') || badgeText.includes('unavailable');
  }

  function moveSoldProducts() {
    if (isProcessing) return;

    const grid = document.querySelector('.main-collection-grid [ref="grid"], .main-collection-grid .product-grid');
    if (!grid) return;

    const cards = Array.from(grid.querySelectorAll(':scope > [ref="cards[]"], :scope > .product-grid__item'));
    if (!cards.length) return;

    const available = [];
    const sold = [];

    cards.forEach((card) => {
      if (productIsUnavailable(card)) {
        sold.push(card);
      } else {
        available.push(card);
      }
    });

    if (!sold.length || !available.length) return;

    const orderedCards = available.concat(sold);
    const alreadySorted = orderedCards.every((card, index) => cards[index] === card);
    if (alreadySorted) return;

    isProcessing = true;

    const fragment = document.createDocumentFragment();
    orderedCards.forEach((card) => fragment.appendChild(card));
    grid.appendChild(fragment);

    window.setTimeout(() => {
      isProcessing = false;
    }, 50);
  }

  function scheduleMoveSoldProducts() {
    window.clearTimeout(queuedRun);
    queuedRun = window.setTimeout(moveSoldProducts, 100);
  }

  function init() {
    scheduleMoveSoldProducts();

    const observer = new MutationObserver(scheduleMoveSoldProducts);
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
